import React from "react";
import { MessageCircle, PhoneCall } from "lucide-react";
import { getPhoneHref, getWhatsAppHref, isNormalizedPhone } from "../lib/phone";

const ACTION_STYLES = {
  neutral: "border-slate-200 bg-white text-slate-600 hover:bg-slate-50",
  call: "border-sky-200 bg-sky-50 text-sky-800 hover:bg-sky-100",
  whatsapp: "border-emerald-200 bg-emerald-50 text-emerald-800 hover:bg-emerald-100",
};

function styleFor(kind, preferredContactMethod) {
  if (preferredContactMethod === "call" && kind === "call") return ACTION_STYLES.call;
  if (preferredContactMethod === "whatsapp" && kind === "whatsapp") return ACTION_STYLES.whatsapp;
  return ACTION_STYLES.neutral;
}

export function AdminPhoneActions({ phone, preferredContactMethod, testIdPrefix = "admin-phone" }) {
  if (!isNormalizedPhone(phone)) return null;

  const telHref = getPhoneHref(phone);
  const waHref = getWhatsAppHref(phone);

  return (
    <div className="mt-2 flex flex-wrap items-center gap-1.5" data-testid={`${testIdPrefix}-actions`}>
      <a
        href={telHref}
        data-testid={`${testIdPrefix}-call`}
        className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-[11px] font-semibold transition-colors ${styleFor("call", preferredContactMethod)}`}
      >
        <PhoneCall size={12} />
        {preferredContactMethod === "call" ? "Call preferred" : "Call"}
      </a>
      {waHref && (
        <a
          href={waHref}
          target="_blank"
          rel="noreferrer"
          data-testid={`${testIdPrefix}-whatsapp`}
          className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-[11px] font-semibold transition-colors ${styleFor("whatsapp", preferredContactMethod)}`}
        >
          <MessageCircle size={12} />
          {preferredContactMethod === "whatsapp" ? "WhatsApp preferred" : "WhatsApp"}
        </a>
      )}
    </div>
  );
}